"use strict";
import { initializeCommentsDropdown } from "../../decidim/comments/comments_dropdown";
const addCommentMobile = function(addCommentCard) {
  addCommentCard.classList.remove("hidden");
  addCommentCard.classList.add("fullscreen");
};
const closeAddComment = function(addCommentCard) {
  addCommentCard.classList.add("hidden");
  addCommentCard.classList.remove("fullscreen");
};
document.addEventListener("turbo:load", () => {
  const addCommentCard = document.getElementById("add-comment-anchor");
  if (addCommentCard) {
    document.querySelectorAll(".add-comment-mobile").forEach((addButtonMobile) => {
      addButtonMobile.addEventListener("click", () => {
        addCommentMobile(addCommentCard);
      });
    });
  }
  const closeButton = document.querySelector(
    "#add-comment-anchor .close-add-comment-fullscreen"
  );
  if (closeButton) {
    closeButton.addEventListener(
      "click",
      () => closeAddComment(addCommentCard)
    );
  }
  initializeCommentsDropdown(document);
});
